import React from 'react'
import { ListGroup } from "react-bootstrap";
import Project from "./project";


const ProjectList = ({projects, titel}) => {    
    return (
        <section className="mb-3">            
            <h2 style={{ textTransform: 'capitalize'}}>{titel}</h2>
            <div>
                <ListGroup variant='flush'>
                    {projects.sort((node1, node2) => {                        
                        return new Date(node2.node.frontmatter.date) - new Date(node1.node.frontmatter.date)
                    }).map(({ node }, index) => (
                          <Project node={node} key={index}></Project>
                    ))
                    }
                </ListGroup>
            </div>
        </section>
    )
}

export default ProjectList
